import { Model } from 'pinia-orm';
import VdabJob from './VdabJob';

export default class Location extends Model {

    static get entity () {
        return 'locations';
    }

    static fields () {
        return {
            id: this.uid(),
            vdab_id: this.attr(null),
            lat: this.attr(''),
            lng: this.attr(''),
            is_hq: this.attr(false),
            city: this.attr(''),
            region: this.attr(''),
            group: this.attr(''),
            postal_code: this.attr(''),
            street: this.attr(''),
            phone: this.attr(''),
            email: this.attr(''),
            country: this.attr(''),
            country_code: this.attr(''),
            thumbnail_url: this.attr(''),
            alias: this.attr({}),
            order: this.attr(0),
            pivot: this.attr(null),
            created_at: this.attr(null),
            updated_at: this.attr(null),

            //relationships
            vdabJob: this.hasMany(VdabJob, 'company_location_id'),
        }
    }
}
